import { render, staticRenderFns } from "./logDevice.vue?vue&type=template&id=505d7628&scoped=true"
import script from "./logDevice.vue?vue&type=script&lang=js"
export * from "./logDevice.vue?vue&type=script&lang=js"
import style0 from "./logDevice.vue?vue&type=style&index=0&id=505d7628&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505d7628",
  null
  
)

export default component.exports